interface IAppState {
  isOnline: boolean;
  languageCode: string;
  backgroundWorker: any[];
  isSupervisorMode?: boolean;
  lockedProject?: { label: string; value: string } | null;
}

const initialState: IAppState = {
  isOnline: navigator.onLine,
  languageCode: 'en',
  backgroundWorker: [],
  isSupervisorMode: false,
  lockedProject: null,
};

export default initialState;
